import { UIView, type UIViewInjectedProps } from '@uirouter/react';
import { Layout as AntdLayout } from 'antd';
import { useState } from 'react';

import { Header } from '@/components';
import { Menu } from '@/components/menu';

const { Content } = AntdLayout;

export const Layout = ({ transition }: UIViewInjectedProps) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    setCollapsed((prevCollapsed: boolean) => !prevCollapsed);
  };

  const defaultSelectedKey = transition.router.globals.current.name.split('.')[1];

  return (
    <AntdLayout className="main-layout">
      <Header collapsed={collapsed} toggle={toggle} />
      <AntdLayout>
        <Menu collapsed={collapsed} defaultSelectedKey={defaultSelectedKey} />
        <Content className="content">
          <UIView />
        </Content>
      </AntdLayout>
    </AntdLayout>
  );
};

export const states = [
  {
    name: 'base-layout',
    component: Layout,
    data: {
      requiresAuth: true,
    },
  },
];
